// extracted by mini-css-extract-plugin
export default {"backdrop":"BackDrop_backdrop__MgSC+"};